import { parseStr } from '@shared/helpers/cost-basis';
import { GiftingDesignationTypes, GiftRecipientTypes, GiftThresholds } from '@shared/models';
import { FeatureToggleState } from '@store/reducers/feature/feature.reducer';
import {
  getRecipientType,
  getTotalGiftAmount,
  GiftingState,
} from '@store/reducers/gifting/gifting.reducer';
import { MXMState } from '@store/reducers/mxm/mxm.reducer';
import { getGiftingDesignationSelection, TriageState } from '@store/reducers/triage/triage.reducer';

export const getGiftingOverviewNextPage = (): string => 'gifting/triage';
export const getGiftingTriageNextPage = (): string => 'gifting/summary';
export const getGiftingAssetsNextPage = (): string => 'secure/gifting/method/1';
export const getGiftingRecipientNextPage = (): string => 'secure/gifting/review';

export enum RedirectUrls {
  INTELLEDOX = 'secure/gifting/intelledox-redirect',
  ESIGN = 'secure/gifting/terms/gift-existing',
  ESIGN_MULTI_SIGNER = 'secure/gifting/terms/gift-existing-multisigner',
}

export const getGiftingReviewNextPage = (
  mxmState: MXMState,
  featureToggleState: FeatureToggleState,
): string => {
  const isMXM2Flow: boolean = mxmState.signState !== null && mxmState.transferId !== null;
  const isMXMEnablementToggleOn = featureToggleState.cwp_updated_mxm_enablement;
  const esign_route =
    isMXMEnablementToggleOn && isMXM2Flow ? RedirectUrls.ESIGN_MULTI_SIGNER : RedirectUrls.ESIGN;

  return esign_route;
};

export const getGiftingTermsNextPage = (
  mxmState: MXMState,
  featureToggleState: FeatureToggleState,
): string => {
  const isMXM2Flow: boolean = mxmState.signState !== null && mxmState.transferId !== null;
  const isMXMEnablementToggleOn = featureToggleState.cwp_updated_mxm_enablement;

  return isMXMEnablementToggleOn && isMXM2Flow
    ? `secure/gifting/confirm-multisigner`
    : 'secure/gifting/confirm';
};
export const getGiftingRecipientTriageNextPage = (): string => 'secure/gifting/recipient';
export const getGiftingMethodNextPage = (): string => 'secure/gifting/recipient-triage';
